export default "__VITE_ASSET__DGOdfgva__"